import React, { useEffect, useState } from 'react';

export default function SplashScreen({ onFinish }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 900);
    const finishTimer = setTimeout(() => onFinish?.(), 1300);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-400 ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-4 splash-pop">
        <img
          src="/logo.png"
          alt="Errands Boy"
          className="w-40 h-40 md:w-56 md:h-56 object-contain"
        />
        <div className="flex gap-1 mt-4">
          <span className="w-2 h-2 bg-slate-900 rounded-full splash-dot" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-yellow-500 rounded-full splash-dot" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-slate-900 rounded-full splash-dot" style={{ animationDelay: '300ms' }}></span>
        </div>
      </div>
    </div>
  );
}
